import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import { DetailList } from '../DetailList';
import { thirdPartyMakeModel } from '../../utils/thirdPartyAgreementView';
import type { ThirdPartyVehicle } from '../../types/thirdPartyAgreement.types';

interface Props {
    vehicle: ThirdPartyVehicle;
}

const headingId = 'third-party-vehicle-heading';

export function ThirdPartyVehiclePanel({ vehicle }: Props) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>Vehicle</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId}>
                    <DetailList
                        emptyMessage="No vehicle details were returned for this agreement."
                        fields={[
                            { label: 'Make / model', value: thirdPartyMakeModel(vehicle) },
                            { label: 'VRM', value: vehicle.registration },
                            { label: 'VIN', value: vehicle.vin },
                        ]}
                    />
                </section>
            </CardContent>
        </Card>
    );
}
